// @ts-ignore
import StringMask from "string-mask";

const formatter = new StringMask("AA:AA");

export function formatTime(value: string) {
  return formatter.apply(value);
}
